import type {AddItemOptionsProps} from '@Components/poster-editor/components/poster-add-item-bar/poster-add-item-bar.types';

export interface AddAiItemButtonProps extends AddItemOptionsProps {}

export enum AddAiItemPopOverContentState {
  AI_ITEMS_DROPDOWN = 'AI_ITEMS_DROPDOWN',
  AI_IMAGE = 'AI_IMAGE',
  AI_SUBTITLES = 'AI_SUBTITLES',
  AI_VOICE = 'AI_VOICE',
}

export const AI_IMAGE_PANEL_ID = 'TEXT_TO_IMAGE_LEFT_POP_OVER_AI_MENU';
export const AI_VOICE_PANEL_ID = 'TEXT_TO_SPEECH_LEFT_POP_OVER_AI_MENU';
export const AI_SUBTITLE_PANEL_ID = 'AI_SUBTITLES_LEFT_POP_OVER_AI_MENU';
